module.exports = __webpack_public_path__ + "img/what-we-can-do.fba52584.jpg";